let GOOGLE_CLIENT_ID: string = process.env.REACT_APP_GOOGLE_CLIENT_ID!;

export {
    GOOGLE_CLIENT_ID
}